export const readEmpty = async (skip,query,searchThis,address1,status,khusus) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listSuratMasukCompanyEmpty?skip=${skip}&query=${query}&SearchThis=${searchThis}&lokasi=${address1}&status=${status}&khusus=${khusus}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}